import gql from 'graphql-tag';

export default gql`
    mutation UpdateBoxInLoad($input: UpdateBoxInLoadInput) {
        updateBoxInLoad(input: $input) {
            errors
        }
    }
`;
